import { render } from "./tradingHall.vue?vue&type=template&id=ed91f54c&scoped=true"
import script from "./tradingHall.vue?vue&type=script&lang=js"
export * from "./tradingHall.vue?vue&type=script&lang=js"

import "./tradingHall.vue?vue&type=style&index=0&id=ed91f54c&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed91f54c"]])

export default __exports__